/* unplugin-vue-components disabled */import { render } from "./DeviceBssid.vue?vue&type=template&id=ccb5c066&scoped=true"
import script from "./DeviceBssid.vue?vue&type=script&lang=js"
export * from "./DeviceBssid.vue?vue&type=script&lang=js"

import "./DeviceBssid.vue?vue&type=style&index=0&id=ccb5c066&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/txgy-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccb5c066"]])

export default __exports__